import { isServer } from './is-server';
/**
 * 获取UserAgent
 * @param ua {string} 浏览器userAgent,不传或者传空字符串则自动获取
 */
export function getUserAgent(ua) {
    if (ua === void 0) { ua = ''; }
    if (isServer) {
        if (!ua) {
            console.warn('warning：在node端调用getUserAgent方法未传入ua参数，会导致node端识别ua不准确！');
        }
        return ua || '';
    }
    return ua || window.navigator.userAgent || '';
}
